


















import { Vue, Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";

@Component({ components: { Modal, CustomButton } })
export default class CPageButtons extends Vue {
  @Prop() type!: "new" | "edit";
  @Prop() disable!: boolean;

  accept() {
    this.$emit("accept");
  }

  remove() {
    this.$emit("remove");
  }

  decline() {
    this.$emit("decline");
  }
}
